import {AxiosResponse} from 'axios';
import {IconInfo} from '../backend/enums/icon-info';
import {IconsCatalog} from '../backend/enums/icons-catalog';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class IconsRepository {
  // Singleton Instance
  private static _instance: IconsRepository;

  // Private
  private logger: Logger;

  static get instance(): IconsRepository {
    if (!this._instance) {
      this._instance = new IconsRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('IconsRepository');
  }

  // Get all icons in a catalog
  public async getByCatalog(catalog: IconsCatalog): Promise<Array<IconInfo>> {
    // Get from backend
    const result: AxiosResponse<Array<IconInfo>> = await BackendApiManager.instance.get<
      Array<IconInfo>
    >(`/storage/icons?catalog=${catalog}`);

    // Return
    return result.data;
  }
}
